import React from "react";
import PropTypes from "prop-types";
import Spinner from "react-bootstrap/Spinner";

const RLCloudSandboxError = ({ dataError, isAnalyzing, displayStatus }) => (
  <>
    <div className="mb-10">{dataError}</div>
    <div>
      <b className="me-5">Status:</b>
      {isAnalyzing && (
        <Spinner
          animation="border"
          size="sm"
          variant="secondary"
          className="me-5"
        />
      )}
      <b>{displayStatus}</b>
    </div>
  </>
);

RLCloudSandboxError.propTypes = {
  dataError: PropTypes.string,
  isAnalyzing: PropTypes.bool,
  displayStatus: PropTypes.string
};

export default RLCloudSandboxError;
